import apiClient from './client';
import type {
  LoginRequest,
  LoginResponse,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  User,
} from '@/types/auth';

export async function login(email: string, password: string): Promise<LoginResponse> {
  const payload: LoginRequest = { email, password };
  const response = await apiClient.post<LoginResponse>('/auth/login/', payload);
  return response.data;
}

export async function logout(): Promise<void> {
  try {
    await apiClient.post('/auth/logout/');
  } finally {
    localStorage.removeItem('access_token');
  }
}

export async function forgotPassword(email: string): Promise<void> {
  const payload: ForgotPasswordRequest = { email };
  await apiClient.post('/auth/forgot-password/', payload);
}

export async function resetPassword(token: string, password: string): Promise<void> {
  const payload: ResetPasswordRequest = {
    token,
    password,
    password_confirmation: password,
  };
  await apiClient.post('/auth/reset-password/', payload);
}

export async function getMe(): Promise<User> {
  const response = await apiClient.get<{
    user: User;
    permissions: string[];
    roles: string[];
    tenant: { id: string; slug: string; name: string };
  }>('/auth/me');
  const { user, permissions, roles } = response.data;
  return {
    ...user,
    permissions,
    roles,
    role: (roles[0] ?? 'viewer') as User['role'],
    first_name: user.first_name || user.name?.split(' ')[0] || '',
    last_name: user.last_name || user.name?.split(' ').slice(1).join(' ') || '',
  };
}

export async function refreshToken(): Promise<string> {
  const response = await apiClient.post<{ token: string }>('/auth/refresh');
  return response.data.token;
}
